<template>
    <div id="app">
        <main-header nowtab="creator"></main-header>
        <main v-if="code === 0" class="adjuster">
            <Title>作者后台 - {{ title }}</Title>
            <div v-if="tower">
                <div class="link-panel panel">
                    <Title :strong="2">链接</Title>
                    <div class="panel-content">
                        <a :href="`/tower?name=${ tower.name }`" target="_blank">评论区</a> |
                        <a href="/up2cos" target="_blank">自助更新</a>
                    </div>
                </div>
                <div class="cover-panel panel">
                    <Title :strong="2">
                        封面
                        <a-button class="cover-helper" type="link" @click="coverHelp">
                            <a-icon type="question-circle" />更换说明
                        </a-button>
                    </Title>
                    <div class="panel-content">
                        <Cover v-bind="tower"></Cover>
                        <div class="cover-form">
                            <a-input :disabled="changingCover" v-model="cover" />
                            <a-button :loading="changingCover" class="button" @click="previewCover">预览</a-button>
                            <a-button :loading="changingCover" class="button" @click="changeCover" type="primary">更换</a-button>
                        </div>
                    </div>
                </div>
                <div class="description-panel panel">
                    <Title :strong="2">简介</Title>
                    <div>{{ tower.description || '还没有简介' }}</div>
                    <a-button @click="openEditDialog">编辑</a-button>
                    <a-modal
                        :title="`编辑简介`"
                        :visible="editorVisible"
                        :confirm-loading="editing"
                        @ok="doEdit"
                        @cancel="() => editorVisible = false"
                        :okCancel="false"
                        width="95%" :maskClosable="false"
                    >
                        <a-textarea v-model="editData" ref="writeboard" auto-size></a-textarea>
                    </a-modal>
                </div>
                <!-- <div v-if="difficultyList" class="difficulty-panel panel">
                    <Title :strong="2">
                        难度
                        <a-button class="difficulty-helper" type="link" @click="difficultyHelp">
                            <a-icon type="question-circle" />难度说明
                        </a-button>
                    </Title>
                    <div class="panel-content">
                        <draggable
                            class="difficulty-list"
                            tag="ul"
                            v-model="difficultyList"
                            v-bind="{
                                animation: 200,
                                group: 'description',
                                disabled: false,
                                ghostClass: 'ghost'
                            }"
                        >
                            <li
                                class="difficulty-list-item"
                                v-for="difficulty in difficultyList"
                                :key="difficulty.label"
                            >
                                {{ difficulty.label }}
                            </li>
                        </draggable>
                            <a-button :loading="changingDifficultList" class="button"
                                @click="useDefaultDifficultList"
                            >设为默认</a-button>
                            <a-button :loading="changingDifficultList" class="button"
                                @click="changeDifficultList" type="primary"
                            >更改</a-button>
                    </div>
                </div> -->
            </div>
        </main>
        <page-404 v-else></page-404>
        <Footer></Footer>
    </div>
</template>

<script>
import MainHeader from '@/components/MainHeader.vue'
import Footer from '@/components/Footer.vue'
import Title from '@/components/Title.vue'
import Cover from '@/components/Cover.vue'
import { createFormData, getSSRdata } from '../../utils/utils'
import axios from 'axios'
import Draggable from 'vuedraggable'
import Page404 from '../../components/Page404.vue'

export default {
    data: () => ({
        code: 0,
        title: '',
        tower: null,
        cover: '',
        difficultyList: null,
        changingCover: false,

        editData: "",
        editing: false,
        editorVisible: false,
    }),
    async created() {
        const {
            code, tower, endingList, difficultyList,
        } = getSSRdata('backstage');
        this.code = code;
        if (code == -1) {
            return;
        }
        this.title = tower.title;
        this.difficultyList = difficultyList;
        this.tower = tower;
        this.cover = tower.image;
        this.description = tower.description;
    },
    methods: {
        coverHelp() {
            const defaultImage = `/games/${this.tower.name}/project/images/bg.jpg`;
            this.$info({
                title: '更换封面说明',
                content: h => (
                    <div class="help-text">
                        <p>你需要输入封面图片的链接来更换图片</p>
                        <p>如果留空，会视为使用<a href={defaultImage} target="_blank">{ defaultImage }</a></p>
                        <p>如果想要使用自己上传的图片，可以在论坛中上传图片，然后右键复制图片链接使用</p>
                        <p>如果想要使用外站图片，请加上 <code>https://</code> ，否则将不会生效</p>
                    </div>
                ),
            });
        },
        previewCover() {
            this.tower.image = this.cover;
        },
        async changeCover() {
            this.changingCover = true;
            try {
                const { data } = await axios
                    .post("/backend/tower/changeCover.php", createFormData({
                        name: this.tower.name, image: this.tower.image
                    }));
                this.tower.image = data.image;
            } catch {
                this.$message.error("未知错误");
            } finally {
                this.changingCover = false;
            }
        },
        difficultyHelp() {
            this.$info({
                title: '难度列表说明',
                content: h => (
                    <div class="help-text">
                        <p>你需要手动指定难度列表，一方面，这可以防止invgod作乱，另一方面，可以方便的更换难度顺序而不用更新游戏</p>
                        <p>你也可以使用默认的难度列表，点击默认，则会更换为与旧版页面相同的难度排序</p>
                    </div>
                ),
            });
        },
        openEditDialog() {
            this.editData = this.description;
            this.editorVisible = true;
        },
        async doEdit() {
            this.editing = true;
            try {
                const { data } = await axios
                    .post("/backend/tower/changeDescription.php", createFormData({
                        name: this.tower.name, description: this.editData
                    }));
                this.tower.description = data.description;
            } catch {
                this.$message.error("未知错误");
            }
            this.editing = false;
            this.editorVisible = false;
        }
    },
    watch: {
        title(newvalue, oldvalue) {
            document.title = `${ newvalue } - 后台 - HTML5魔塔广场`;
        }
    },
    components: {
        MainHeader, Footer, Title, Draggable, Cover,
        Page404,
    },
}
</script>

<style>
html, body {
    height: 100%;
    width: 100%;
    margin: 0;
}
#app {
    font-family: Avenir, Helvetica, Arial, sans-serif;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    text-align: center;
    color: #2c3e50;
    min-height: 100%;
    display: flex;
    flex-direction: column;
    cursor: default;
}
</style>

<style lang="less" scoped>
.adjuster {
    margin: 20px auto;
    @media screen and (min-width: 1000px) {
        width: 1000px;
    }
    @media screen and (max-width: 999px) {
        width: 100%;
    }
}
.panel {
    text-align: left;
    margin-left: 5px;
}
.panel-content {
    margin-left: 10px;
}
.cover-form {
    display: flex;
    max-width: 500px;
    margin: 20px;
    .button {
        margin-left: 20px;
    }
}
.difficulty-panel {
    .button {
        margin-left: 20px;
    }
}
.cover-helper, .difficulty-helper {
    color: rgba(0, 0, 0, 0.45);
}
</style>
